import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";
import { RECOIL_PERSIST_KEY } from "../sharedStrings";

const { persistAtom } = recoilPersist({
  key: RECOIL_PERSIST_KEY,
});

export interface CurrentShip {
  shipTypeId: number;
  shipTypeNo: string;
  shipTypeName: string;
  shipId: number;
  shipNo: string;
  shipName: string;
}

export const selectedShipTypesState = atom<number[]>({
  key: `selectedShipTypesState`,
  default: [],
  effects_UNSTABLE: [persistAtom],
});

export const currentShipState = atom<CurrentShip>({
  key: "selectedShipState",
  default: {
    shipTypeId: Number(process.env.REACT_APP_DEFAULT_SHIP_TYPE_ID) || 1,
    shipTypeNo: process.env.REACT_APP_DEFAULT_SHIP_TYPE_NO || "1",
    shipTypeName: process.env.REACT_APP_DEFAULT_SHIP_TYPE_NAME || "1000",
    shipId: Number(process.env.REACT_APP_DEFAULT_SHIP_ID) || 1,
    shipNo: process.env.REACT_APP_DEFAULT_SHIP_NO || "1-1",
    shipName: process.env.REACT_APP_DEFAULT_SHIP_NAME || "1005함",
  },
  effects_UNSTABLE: [persistAtom],
});
